export const FULLPAGE_JS_API = "7691DC24-12CF457D-A0C93E8E-D21BE4A1";
